// extracted by mini-css-extract-plugin
export default {"wrapper":"ClearInputBtn_wrapper__7W5It","clearBtn":"ClearInputBtn_clearBtn__YMPh9"};